<div class="vf-tiptap-wrapper d-flex flex-column" [style.height]="height"
     [class.is-file-drag-over]="isFileDragOver"
     (dragenter)="onShellDragEnter($event)"
     (dragover)="onShellDragOver($event)"
     (dragleave)="onShellDragLeave($event)"
     (drop)="onShellDrop($event)">

    <!-- Built-in formatting toolbar (opt-in via [showToolbar]).
         `--menu` lifts the row (and with it whatever dropdown is hanging off it) over the proofread pill,
         which floats just below the toolbar: without it the pill covered the "Proofread" row of the
         Write-with-AI menu, so the one action you'd want next after a proofread was unclickable. The lift
         is conditional because the bubble menu must keep winning over the plain toolbar. -->
    <div class="vf-tiptap-toolbar" *ngIf="showToolbar && !readonly"
         [class.vf-tiptap-toolbar--menu]="showTbWriteAiMenu || moreMenuOpen"
         [class.vf-tiptap-toolbar--collapsible]="collapsibleToolbar"
         (mousedown)="$event.target === $event.currentTarget && $event.preventDefault()">

        <ng-content select="[toolbar-leading]"></ng-content>

        <!-- Write with AI dropdown: Proofread + Ask AI to write something -->
        <div class="vf-tiptap-tb-pop" *ngIf="showProofread && showWriteAiToolbar">
            <button type="button"
                    class="vf-tiptap-tb-btn vf-tiptap-tb-btn-write-ai"
                    title="Write with AI"
                    (mousedown)="$event.preventDefault()"
                    (click)="toggleTbWriteAiMenu($event)">
                <lucide-icon name="sparkles" [size]="14" [strokeWidth]="2"></lucide-icon>
                <span>Write with AI</span>
                <lucide-icon name="chevron-down" [size]="12" [strokeWidth]="2"></lucide-icon>
            </button>
            <div class="vf-tiptap-bubble-pop-menu vf-tiptap-write-ai-menu vf-tiptap-write-ai-menu--fixed"
                 *ngIf="showTbWriteAiMenu" [ngStyle]="tbWriteAiMenuStyle">
                <button type="button" class="vf-tiptap-write-ai-item"
                        (mousedown)="$event.preventDefault()"
                        (click)="pickWriteAiOption('proofread')">
                    <lucide-icon name="sparkles" [size]="14" [strokeWidth]="2" class="vf-tiptap-write-ai-icon vf-tiptap-write-ai-icon-proofread"></lucide-icon>
                    <span class="vf-tiptap-write-ai-text">
                        <span class="vf-tiptap-write-ai-title">Proofread</span>
                        <span class="vf-tiptap-write-ai-sub">Fix grammar and typos</span>
                    </span>
                </button>
                <button type="button" class="vf-tiptap-write-ai-item"
                        (click)="pickWriteAiOption('ask')">
                    <lucide-icon name="pencil-line" [size]="14" [strokeWidth]="2" class="vf-tiptap-write-ai-icon vf-tiptap-write-ai-icon-ask"></lucide-icon>
                    <span class="vf-tiptap-write-ai-text">
                        <span class="vf-tiptap-write-ai-title">Ask AI to write something</span>
                        <span class="vf-tiptap-write-ai-sub">Let AI write or improve your notes</span>
                    </span>
                </button>
            </div>
        </div>

        <span class="vf-tiptap-tb-sep" *ngIf="showProofread && showWriteAiToolbar"></span>

        <!-- Standalone Proofread button (no dropdown) — used by surfaces
             like the step/checklist modal that want only the proofread
             action, not the full Write-with-AI flow. -->
        <button type="button"
                class="vf-tiptap-tb-btn vf-tiptap-tb-btn-write-ai"
                title="Proofread"
                *ngIf="showProofread && showProofreadButton"
                (mousedown)="$event.preventDefault()"
                (click)="emitProofread()">
            <lucide-icon name="check" [size]="14" [strokeWidth]="2" class="vf-tiptap-proofread-btn-icon"></lucide-icon>
            <span>Proofread</span>
        </button>
        <span class="vf-tiptap-tb-sep" *ngIf="showProofread && showProofreadButton"></span>

        <!-- `tbShow()` is always true unless [collapsibleToolbar] is on; when it is, buttons drop out in
             priority order as the row narrows and reappear in the `···` menu below. -->
        <button type="button" class="vf-tiptap-tb-btn" title="Bold" *ngIf="tbShow('bold')"
                [class.is-active]="isMarkActive('bold')"
                (mousedown)="$event.preventDefault()" (click)="toolbarAction('bold')">
            <lucide-icon name="bold" [size]="16" [strokeWidth]="2"></lucide-icon>
        </button>
        <button type="button" class="vf-tiptap-tb-btn" title="Italic" *ngIf="tbShow('italic')"
                [class.is-active]="isMarkActive('italic')"
                (mousedown)="$event.preventDefault()" (click)="toolbarAction('italic')">
            <lucide-icon name="italic" [size]="16" [strokeWidth]="2"></lucide-icon>
        </button>
        <button type="button" class="vf-tiptap-tb-btn" title="Underline" *ngIf="tbShow('underline')"
                [class.is-active]="isMarkActive('underline')"
                (mousedown)="$event.preventDefault()" (click)="toolbarAction('underline')">
            <lucide-icon name="underline" [size]="16" [strokeWidth]="2"></lucide-icon>
        </button>
        <button type="button" class="vf-tiptap-tb-btn" title="Strikethrough" *ngIf="tbShow('strike')"
                [class.is-active]="isMarkActive('strike')"
                (mousedown)="$event.preventDefault()" (click)="toolbarAction('strikeThrough')">
            <lucide-icon name="strikethrough" [size]="16" [strokeWidth]="2"></lucide-icon>
        </button>

        <span class="vf-tiptap-tb-sep" *ngIf="tbShow('bullet') || tbShow('numbered') || tbShow('checklist')"></span>

        <button type="button" class="vf-tiptap-tb-btn" title="Bullet list" *ngIf="tbShow('bullet')"
                [class.is-active]="isMarkActive('bulletList')"
                (mousedown)="$event.preventDefault()" (click)="toolbarAction('insertUnorderedList')">
            <lucide-icon name="list" [size]="16" [strokeWidth]="2"></lucide-icon>
        </button>
        <button type="button" class="vf-tiptap-tb-btn" title="Numbered list" *ngIf="tbShow('numbered')"
                [class.is-active]="isMarkActive('orderedList')"
                (mousedown)="$event.preventDefault()" (click)="toolbarAction('insertOrderedList')">
            <lucide-icon name="list-ordered" [size]="16" [strokeWidth]="2"></lucide-icon>
        </button>
        <button type="button" class="vf-tiptap-tb-btn" title="Checkbox list" *ngIf="tbShow('checklist')"
                [class.is-active]="isMarkActive('taskList')"
                (mousedown)="$event.preventDefault()" (click)="toolbarAction('insertTaskList')">
            <lucide-icon name="list-checks" [size]="16" [strokeWidth]="2"></lucide-icon>
        </button>

        <span class="vf-tiptap-tb-sep" *ngIf="tbShow('indent')"></span>

        <button type="button" class="vf-tiptap-tb-btn" title="Increase indent" *ngIf="tbShow('indent')"
                (mousedown)="$event.preventDefault()" (click)="toolbarAction('indent')">
            <lucide-icon name="indent-increase" [size]="16" [strokeWidth]="2"></lucide-icon>
        </button>
        <button type="button" class="vf-tiptap-tb-btn" title="Decrease indent" *ngIf="tbShow('outdent')"
                (mousedown)="$event.preventDefault()" (click)="toolbarAction('outdent')">
            <lucide-icon name="indent-decrease" [size]="16" [strokeWidth]="2"></lucide-icon>
        </button>

        <!-- The four combo pickers render HERE normally, but move into the `···` menu when the toolbar is
             collapsible — the design keeps them out of the row entirely, which is what buys the gap
             between "TASK NOTES" and the buttons. ngTemplateOutlet so the markup exists once. -->
        <ng-container *ngIf="!collapsibleToolbar">
            <span class="vf-tiptap-tb-sep"></span>
            <ng-container *ngTemplateOutlet="tbCombosColor"></ng-container>
        </ng-container>

        <ng-template #tbCombosColor>
        <!-- Text color -->
        <div class="vf-tiptap-tb-pop">
            <button type="button" class="vf-tiptap-tb-btn vf-tiptap-tb-btn-combo" title="Text color"
                    (mousedown)="$event.preventDefault()" (click)="toggleTbColorPicker($event)">
                <lucide-icon name="palette" [size]="16" [strokeWidth]="2"></lucide-icon>
                <lucide-icon name="chevron-down" [size]="10" [strokeWidth]="2"></lucide-icon>
            </button>
            <div class="vf-tiptap-bubble-pop-menu vf-tiptap-color-menu" *ngIf="showTbColorPicker">
                <div class="vf-tiptap-swatch-grid">
                    <button type="button"
                            *ngFor="let c of textColorPalette"
                            class="vf-tiptap-swatch"
                            [style.background]="c"
                            [title]="c"
                            (click)="toolbarAction('fontColor', c)"></button>
                </div>
                <button type="button" class="vf-tiptap-pop-clear" (click)="toolbarAction('fontColor', null)">Default color</button>
            </div>
        </div>

        <!-- Highlight -->
        <div class="vf-tiptap-tb-pop">
            <button type="button" class="vf-tiptap-tb-btn vf-tiptap-tb-btn-combo" title="Highlight"
                    (mousedown)="$event.preventDefault()" (click)="toggleTbHighlightPicker($event)">
                <lucide-icon name="highlighter" [size]="16" [strokeWidth]="2"></lucide-icon>
                <lucide-icon name="chevron-down" [size]="10" [strokeWidth]="2"></lucide-icon>
            </button>
            <div class="vf-tiptap-bubble-pop-menu vf-tiptap-color-menu" *ngIf="showTbHighlightPicker">
                <div class="vf-tiptap-swatch-grid">
                    <button type="button"
                            *ngFor="let c of highlightPalette"
                            class="vf-tiptap-swatch"
                            [class.is-no-color]="c === null"
                            [style.background]="c"
                            [title]="c === null ? 'No highlight' : c"
                            (click)="toolbarAction('backgroundColor', c)"></button>
                </div>
                <button type="button" class="vf-tiptap-pop-clear" (click)="toolbarAction('backgroundColor', null)">No highlight</button>
            </div>
        </div>
        </ng-template>

        <span class="vf-tiptap-tb-sep" *ngIf="tbShow('link')"></span>

        <button type="button" class="vf-tiptap-tb-btn" title="Insert link" *ngIf="tbShow('link')"
                [class.is-active]="isMarkActive('link')"
                (mousedown)="$event.preventDefault()" (click)="toolbarAction('createLink')">
            <lucide-icon name="link-2" [size]="16" [strokeWidth]="2"></lucide-icon>
        </button>

        <ng-container *ngIf="!collapsibleToolbar">
            <span class="vf-tiptap-tb-sep"></span>
            <ng-container *ngTemplateOutlet="tbCombosBlock"></ng-container>
        </ng-container>

        <ng-template #tbCombosBlock>
        <!-- Font size -->
        <div class="vf-tiptap-tb-pop">
            <button type="button" class="vf-tiptap-tb-btn vf-tiptap-tb-btn-combo" title="Font size"
                    (mousedown)="$event.preventDefault()" (click)="toggleTbFontSizeMenu($event)">
                <lucide-icon name="type" [size]="16" [strokeWidth]="2"></lucide-icon>
                <lucide-icon name="chevron-down" [size]="10" [strokeWidth]="2"></lucide-icon>
            </button>
            <div class="vf-tiptap-bubble-pop-menu vf-tiptap-fontsize-menu" *ngIf="showTbFontSizeMenu">
                <button type="button"
                        *ngFor="let s of fontSizePresets"
                        class="vf-tiptap-fontsize-item"
                        (click)="toolbarAction('fontSize', s)">
                    {{ s }}
                </button>
                <button type="button" class="vf-tiptap-fontsize-item" (click)="toolbarAction('fontSize', null)">Default</button>
            </div>
        </div>

        <span class="vf-tiptap-tb-sep"></span>

        <!-- Table -->
        <div class="vf-tiptap-tb-pop">
            <button type="button" class="vf-tiptap-tb-btn vf-tiptap-tb-btn-combo" title="Table"
                    (mousedown)="$event.preventDefault()" (click)="toggleTbTableMenu($event)">
                <lucide-icon name="table" [size]="16" [strokeWidth]="2"></lucide-icon>
                <lucide-icon name="chevron-down" [size]="10" [strokeWidth]="2"></lucide-icon>
            </button>
            <div class="vf-tiptap-bubble-pop-menu vf-tiptap-table-menu" *ngIf="showTbTableMenu">
                <button type="button" class="vf-tiptap-table-menu-item" (click)="toolbarAction('insertTable')">
                    <lucide-icon name="table" [size]="14" [strokeWidth]="2"></lucide-icon>
                    <span>Insert table</span>
                </button>
                <div class="vf-tiptap-table-menu-sep" *ngIf="isTableActive()"></div>
                <ng-container *ngIf="isTableActive()">
                    <button type="button" class="vf-tiptap-table-menu-item" (click)="toolbarAction('addRowBefore')">
                        <lucide-icon name="arrow-up" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Insert row above</span>
                    </button>
                    <button type="button" class="vf-tiptap-table-menu-item" (click)="toolbarAction('addRowAfter')">
                        <lucide-icon name="arrow-down" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Insert row below</span>
                    </button>
                    <button type="button" class="vf-tiptap-table-menu-item" (click)="toolbarAction('addColumnBefore')">
                        <lucide-icon name="arrow-left" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Insert column left</span>
                    </button>
                    <button type="button" class="vf-tiptap-table-menu-item" (click)="toolbarAction('addColumnAfter')">
                        <lucide-icon name="arrow-right" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Insert column right</span>
                    </button>
                    <div class="vf-tiptap-table-menu-sep"></div>
                    <button type="button" class="vf-tiptap-table-menu-item" (click)="toolbarAction('toggleHeaderRow')">
                        <lucide-icon name="panel-top" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Toggle header row</span>
                    </button>
                    <button type="button" class="vf-tiptap-table-menu-item" (click)="toolbarAction('mergeOrSplit')">
                        <lucide-icon name="combine" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Merge / split cells</span>
                    </button>
                    <div class="vf-tiptap-table-menu-sep"></div>
                    <button type="button" class="vf-tiptap-table-menu-item is-destructive" (click)="toolbarAction('deleteRow')">
                        <lucide-icon name="trash-2" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Delete row</span>
                    </button>
                    <button type="button" class="vf-tiptap-table-menu-item is-destructive" (click)="toolbarAction('deleteColumn')">
                        <lucide-icon name="trash-2" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Delete column</span>
                    </button>
                    <button type="button" class="vf-tiptap-table-menu-item is-destructive" (click)="toolbarAction('deleteTable')">
                        <lucide-icon name="trash-2" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Delete table</span>
                    </button>
                </ng-container>
            </div>
        </div>
        </ng-template>

        <!-- Overflow "···" — rendered only when [collapsibleToolbar] is on, so the default toolbar is
             byte-identical to before. Holds the four combo pickers permanently (per design) plus
             whatever the current width pushed out. Rows reuse the same toolbarAction/isMarkActive the
             inline buttons use, so behaviour can't drift. -->
        <div class="vf-tiptap-tb-pop" *ngIf="collapsibleToolbar">
            <button type="button" class="vf-tiptap-tb-btn" title="More formatting"
                    aria-haspopup="menu" [attr.aria-expanded]="moreMenuOpen"
                    (mousedown)="$event.preventDefault()" (click)="toggleMoreMenu()">
                <!-- `ellipsis`, not `more-horizontal`: only the former is in the app's picked lucide set. -->
                <lucide-icon name="ellipsis" [size]="16" [strokeWidth]="2"></lucide-icon>
            </button>
            <div class="vf-tiptap-tb-backdrop" *ngIf="moreMenuOpen" (click)="closeMoreMenu()"></div>
            <div class="vf-tiptap-more-menu" *ngIf="moreMenuOpen" role="menu">
                <button type="button" class="vf-tiptap-more-item" role="menuitem"
                        *ngFor="let t of overflowTools"
                        [class.is-active]="t.mark && isMarkActive(t.mark)"
                        (mousedown)="$event.preventDefault()" (click)="runOverflowTool(t)">
                    <lucide-icon [name]="t.icon" [size]="15" [strokeWidth]="2"></lucide-icon>
                    <span class="vf-tiptap-more-label">{{ t.title }}</span>
                </button>
                <!-- The combo pickers keep their own popups; they just live in here now. -->
                <div class="vf-tiptap-more-combos">
                    <ng-container *ngTemplateOutlet="tbCombosColor"></ng-container>
                    <ng-container *ngTemplateOutlet="tbCombosBlock"></ng-container>
                </div>
            </div>
        </div>

        <span class="vf-tiptap-tb-spacer"></span>

        <ng-content select="[toolbar-trailing]"></ng-content>
    </div>

    <!-- Proofread status pill — floats centered over the top of the CONTENT.
         While the AI request is in flight, it shows a spinner + "Proofreading…".
         When the response lands the host swaps it to the review state with
         Accept all / Undo all controls.

         The zero-height anchor is what keeps it off the toolbar: pinned to the top of the whole editor
         instead, the pill sat on top of the "Write with AI" button and swallowed its clicks, so a second
         Proofread was unreachable until the pill had been dismissed. -->
    <div class="vf-tiptap-proofread-pill-anchor" *ngIf="proofreadingInProgress || proofreadReviewVisible">
        <div class="vf-tiptap-proofread-pill-wrap">
            <div class="vf-tiptap-proofread-pill" *ngIf="proofreadingInProgress">
                <span class="vf-tiptap-proofread-spinner" aria-hidden="true"></span>
                <span class="vf-tiptap-proofread-pill-label">Proofreading…</span>
            </div>
            <div class="vf-tiptap-proofread-pill" *ngIf="proofreadReviewVisible && !proofreadingInProgress">
                <lucide-icon name="sparkles" [size]="14" [strokeWidth]="2" class="vf-tiptap-proofread-pill-icon"></lucide-icon>
                <span class="vf-tiptap-proofread-pill-label">{{ proofreadReviewLabel }}</span>
                <button type="button" class="vf-tiptap-proofread-pill-close"
                        title="Dismiss" aria-label="Dismiss"
                        (click)="onProofreadAcceptClick()">
                    <lucide-icon name="x" [size]="14" [strokeWidth]="2"></lucide-icon>
                </button>
                <span class="vf-tiptap-proofread-pill-divider" aria-hidden="true"></span>
                <button type="button" class="vf-tiptap-proofread-pill-decline" (click)="onProofreadUndoClick()">
                    Decline
                </button>
                <button type="button" class="vf-tiptap-proofread-pill-accept" (click)="onProofreadAcceptClick()">
                    <lucide-icon name="check" [size]="14" [strokeWidth]="2"></lucide-icon>
                    <span>Accept all</span>
                </button>
            </div>
        </div>
    </div>

    <div #editorHost
         class="vf-tiptap-content flex-1 w-100"
         [attr.id]="editorId || null"
         [class.vf-tiptap-readonly]="readonly">
    </div>

    <!-- Polite count of the open @ list ("3 people match"), for screen readers only (CO-09). It sits OUTSIDE the popup on purpose:
         the popup is display:none while the list is empty, and a hidden live region is never announced, so "0 people match" would be lost. -->
    <span *ngIf="showSlashMenu" class="sr-only" role="status" aria-live="polite" aria-atomic="true">{{ slashStatusText }}</span>

    <!-- Bubble menu (selection toolbar). ONE dark surface: a white "Comment" button, then Proofread,
         a divider, then the formatting group. Values taken from the design's own markup. -->
    <div #bubbleMenu
         class="vf-tiptap-bubble"
         *ngIf="showBubbleMenu && !readonly"
         [ngStyle]="bubbleStyle"
         (mousedown)="$event.preventDefault()">

        <button type="button" class="vf-tiptap-bubble-comment" title="Comment" *ngIf="showNewComment"
                (click)="emitNewComment()">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            <span>Comment</span>
        </button>

        <ng-container *ngIf="showProofread">
            <button type="button" class="vf-tiptap-bubble-btn vf-tiptap-bubble-proofread" title="Proofread"
                    (click)="emitProofread()">
                <lucide-icon name="sparkles" [size]="16" [strokeWidth]="2"></lucide-icon>
                <span>Proofread</span>
            </button>
            <span class="vf-tiptap-bubble-sep vf-tiptap-bubble-sep-lead"></span>
        </ng-container>

        <div class="vf-tiptap-bubble-group">

        <button type="button" class="vf-tiptap-bubble-btn" title="Bold"
                [class.is-active]="isMarkActive('bold')"
                (click)="bubbleAction('bold')">
            <lucide-icon name="bold" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>

        <button type="button" class="vf-tiptap-bubble-btn" title="Italic"
                [class.is-active]="isMarkActive('italic')"
                (click)="bubbleAction('italic')">
            <lucide-icon name="italic" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>

        <button type="button" class="vf-tiptap-bubble-btn" title="Underline"
                [class.is-active]="isMarkActive('underline')"
                (click)="bubbleAction('underline')">
            <lucide-icon name="underline" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>

        <button type="button" class="vf-tiptap-bubble-btn" title="Strikethrough"
                [class.is-active]="isMarkActive('strike')"
                (click)="bubbleAction('strikeThrough')">
            <lucide-icon name="strikethrough" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>

        <span class="vf-tiptap-bubble-sep"></span>

        <button type="button" class="vf-tiptap-bubble-btn" title="Bullet list"
                [class.is-active]="isMarkActive('bulletList')"
                (click)="bubbleAction('insertUnorderedList')">
            <lucide-icon name="list" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>

        <button type="button" class="vf-tiptap-bubble-btn" title="Numbered list"
                [class.is-active]="isMarkActive('orderedList')"
                (click)="bubbleAction('insertOrderedList')">
            <lucide-icon name="list-ordered" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>

        <button type="button" class="vf-tiptap-bubble-btn" title="Checkbox list"
                [class.is-active]="isMarkActive('taskList')"
                (click)="bubbleAction('insertTaskList')">
            <lucide-icon name="list-checks" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>

        <span class="vf-tiptap-bubble-sep"></span>

        <button type="button" class="vf-tiptap-bubble-btn" title="Increase indent"
                (click)="bubbleAction('indent')">
            <lucide-icon name="indent-increase" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>

        <button type="button" class="vf-tiptap-bubble-btn" title="Decrease indent"
                (click)="bubbleAction('outdent')">
            <lucide-icon name="indent-decrease" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>

        <span class="vf-tiptap-bubble-sep"></span>

        <!-- Font color -->
        <div class="vf-tiptap-bubble-pop">
            <button type="button" class="vf-tiptap-bubble-btn vf-tiptap-bubble-btn-combo" title="Text color"
                    (click)="toggleColorPicker($event)">
                <lucide-icon name="palette" [size]="14" [strokeWidth]="2"></lucide-icon>
                <lucide-icon name="chevron-down" [size]="10" [strokeWidth]="2"></lucide-icon>
            </button>
            <div class="vf-tiptap-bubble-pop-menu vf-tiptap-color-menu" *ngIf="showFontColorPicker">
                <div class="vf-tiptap-swatch-grid">
                    <button type="button"
                            *ngFor="let c of textColorPalette"
                            class="vf-tiptap-swatch"
                            [style.background]="c"
                            [title]="c"
                            (click)="bubbleAction('fontColor', c)"></button>
                </div>
                <button type="button" class="vf-tiptap-pop-clear" (click)="bubbleAction('fontColor', null)">Default color</button>
            </div>
        </div>

        <!-- Highlight -->
        <div class="vf-tiptap-bubble-pop">
            <button type="button" class="vf-tiptap-bubble-btn vf-tiptap-bubble-btn-combo" title="Highlight"
                    (click)="toggleHighlightPicker($event)">
                <lucide-icon name="highlighter" [size]="14" [strokeWidth]="2"></lucide-icon>
                <lucide-icon name="chevron-down" [size]="10" [strokeWidth]="2"></lucide-icon>
            </button>
            <div class="vf-tiptap-bubble-pop-menu vf-tiptap-color-menu" *ngIf="showHighlightPicker">
                <div class="vf-tiptap-swatch-grid">
                    <button type="button"
                            *ngFor="let c of highlightPalette; let i = index"
                            class="vf-tiptap-swatch"
                            [class.is-no-color]="c === null"
                            [style.background]="c"
                            [title]="c === null ? 'No highlight' : c"
                            (click)="bubbleAction('backgroundColor', c)"></button>
                </div>
                <button type="button" class="vf-tiptap-pop-clear" (click)="bubbleAction('backgroundColor', null)">No highlight</button>
            </div>
        </div>

        <span class="vf-tiptap-bubble-sep"></span>

        <button type="button" class="vf-tiptap-bubble-btn" title="Insert link"
                [class.is-active]="isMarkActive('link')"
                (click)="bubbleAction('createLink')">
            <lucide-icon name="link-2" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>

        <span class="vf-tiptap-bubble-sep"></span>

        <!-- Font size -->
        <div class="vf-tiptap-bubble-pop">
            <button type="button" class="vf-tiptap-bubble-btn vf-tiptap-bubble-btn-text" title="Font size"
                    (click)="toggleFontSizeMenu($event)">
                <lucide-icon name="type" [size]="14" [strokeWidth]="2"></lucide-icon>
                <lucide-icon name="chevron-down" [size]="10" [strokeWidth]="2"></lucide-icon>
            </button>
            <div class="vf-tiptap-bubble-pop-menu vf-tiptap-fontsize-menu" *ngIf="showFontSizeMenu">
                <button type="button"
                        *ngFor="let s of fontSizePresets"
                        class="vf-tiptap-fontsize-item"
                        (click)="bubbleAction('fontSize', s)">
                    {{ s }}
                </button>
                <button type="button" class="vf-tiptap-fontsize-item" (click)="bubbleAction('fontSize', null)">Default</button>
            </div>
        </div>

        <!-- Table controls — only when the selection is inside a table. ONE combo, not seven inline
             buttons: inline they pushed the bubble to 968px against its 880px cap, so with nowrap the
             tail spilled outside the box unreachable. Mirrors how the main toolbar already presents
             Table, and keeps the bubble to a single row. -->
        <ng-container *ngIf="isTableActive()">
            <span class="vf-tiptap-bubble-sep"></span>
            <div class="vf-tiptap-bubble-pop">
                <button type="button" class="vf-tiptap-bubble-btn vf-tiptap-bubble-btn-combo" title="Table"
                        (click)="toggleBubbleTableDeleteMenu($event)">
                    <lucide-icon name="table" [size]="14" [strokeWidth]="2"></lucide-icon>
                    <lucide-icon name="chevron-down" [size]="10" [strokeWidth]="2"></lucide-icon>
                </button>
                <div class="vf-tiptap-bubble-pop-menu vf-tiptap-table-menu" *ngIf="showBubbleTableDeleteMenu">
                    <button type="button" class="vf-tiptap-table-menu-item" (click)="bubbleAction('addRowBefore')">
                        <lucide-icon name="arrow-up" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Insert row above</span>
                    </button>
                    <button type="button" class="vf-tiptap-table-menu-item" (click)="bubbleAction('addRowAfter')">
                        <lucide-icon name="arrow-down" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Insert row below</span>
                    </button>
                    <button type="button" class="vf-tiptap-table-menu-item" (click)="bubbleAction('addColumnBefore')">
                        <lucide-icon name="arrow-left" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Insert column left</span>
                    </button>
                    <button type="button" class="vf-tiptap-table-menu-item" (click)="bubbleAction('addColumnAfter')">
                        <lucide-icon name="arrow-right" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Insert column right</span>
                    </button>
                    <div class="vf-tiptap-table-menu-sep"></div>
                    <button type="button" class="vf-tiptap-table-menu-item" (click)="bubbleAction('toggleHeaderRow')">
                        <lucide-icon name="panel-top" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Toggle header row</span>
                    </button>
                    <button type="button" class="vf-tiptap-table-menu-item" (click)="bubbleAction('mergeOrSplit')">
                        <lucide-icon name="combine" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Merge / split cells</span>
                    </button>
                    <div class="vf-tiptap-table-menu-sep"></div>
                    <button type="button" class="vf-tiptap-table-menu-item is-destructive" (click)="bubbleAction('deleteRow')">
                        <lucide-icon name="trash-2" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Delete row</span>
                    </button>
                    <button type="button" class="vf-tiptap-table-menu-item is-destructive" (click)="bubbleAction('deleteColumn')">
                        <lucide-icon name="trash-2" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Delete column</span>
                    </button>
                    <button type="button" class="vf-tiptap-table-menu-item is-destructive" (click)="bubbleAction('deleteTable')">
                        <lucide-icon name="trash-2" [size]="14" [strokeWidth]="2"></lucide-icon>
                        <span>Delete table</span>
                    </button>
                </div>
            </div>
        </ng-container>

        </div>
    </div>

    <!-- Link popover (visit / edit / unlink) -->
    <div #linkPopover
         class="vf-tiptap-linkpop"
         *ngIf="linkPopoverVisible && !readonly"
         [ngStyle]="linkPopoverStyle"
         (mousedown)="$event.preventDefault()">
        <a class="vf-tiptap-linkpop-url"
           [href]="currentLinkHref"
           target="_blank"
           rel="noopener noreferrer"
           (click)="$event.stopPropagation()">{{ currentLinkHref }}</a>
        <span class="vf-tiptap-linkpop-sep"></span>
        <button type="button" class="vf-tiptap-linkpop-btn" title="Visit"
                (click)="visitCurrentLink()">
            <lucide-icon name="external-link" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>
        <button type="button" class="vf-tiptap-linkpop-btn" title="Edit link"
                (click)="editCurrentLink()">
            <lucide-icon name="edit" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>
        <button type="button" class="vf-tiptap-linkpop-btn" title="Remove link"
                (click)="unlinkCurrent()">
            <lucide-icon name="trash-2" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>
    </div>

    <!-- Link input popup (add / edit URL) -->
    <div class="vf-tiptap-link-input-popup"
         *ngIf="showLinkInputPopup"
         (mousedown)="$event.stopPropagation()"
         (click)="$event.stopPropagation()">
        <div class="vf-tiptap-link-input-title">
            {{ linkInputMode === 'edit' ? 'Edit link' : 'Add link' }}
        </div>
        <input #linkInputField type="text"
               class="vf-tiptap-link-input"
               [(ngModel)]="linkInputUrl"
               placeholder="https://example.com"
               (keydown.enter)="$event.preventDefault(); confirmLinkInput()"
               (keydown.escape)="$event.preventDefault(); cancelLinkInput()" />
        <div class="vf-tiptap-link-input-actions">
            <button type="button"
                    class="vf-modal-cancel-btn"
                    (click)="cancelLinkInput()">Cancel</button>
            <button type="button"
                    class="vf-tiptap-link-input-btn vf-tiptap-link-input-btn-primary"
                    (click)="confirmLinkInput()">
                {{ linkInputMode === 'edit' ? 'Save' : 'Add' }}
            </button>
        </div>
    </div>

    <!-- Slash menu popup. Always rendered so the host element is stable
         for the ngAfterViewInit reparent-to-body. Visibility is driven by
         slashStyle.display ('none' until the SlashMenu plugin says visible). -->
    <div #slashPopup
         [class.vf-tiptap-slash]="!useGroupedSlashLayout"
         [class.vf-tiptap-mention-popup]="useGroupedSlashLayout"
         [class.vf-tiptap-slash--empty]="!slashItems?.length && !slashShowsNoMatch"
         [ngStyle]="slashStyle">

        <!-- Legacy flat list (existing hosts) -->
        <ng-container *ngIf="!useGroupedSlashLayout">
            <div *ngFor="let item of slashItems; trackBy: trackBySlashItem; let i = index"
                 class="vf-tiptap-slash-item"
                 [class.is-selected]="i === slashSelectedIndex"
                 (mousedown)="$event.preventDefault()"
                 (click)="selectSlashItem(item, i)">
                <img *ngIf="item.iconUrl" [src]="item.iconUrl" class="vf-tiptap-slash-avatar" alt="">
                <span *ngIf="!item.iconUrl && item.iconInitials" class="vf-tiptap-slash-avatar vf-tiptap-slash-avatar-fallback">{{ item.iconInitials }}</span>
                <i *ngIf="!item.iconUrl && !item.iconInitials && item.iconCss" [class]="item.iconCss"></i>
                <div class="vf-tiptap-slash-text">
                    <div class="vf-tiptap-slash-title">{{ item.text }}</div>
                    <div *ngIf="item.description" class="vf-tiptap-slash-desc">{{ item.description }}</div>
                </div>
            </div>
        </ng-container>

        <!-- Grouped mention picker layout (new) -->
        <ng-container *ngIf="useGroupedSlashLayout">
            <div class="vf-tiptap-mention-header">
                <span class="vf-tiptap-mention-header-label">
                    <ng-container *ngIf="slashQuery">Results for "{{ slashQuery }}"</ng-container>
                    <ng-container *ngIf="!slashQuery">{{ groupedHeaderLabel }}</ng-container>
                </span>
                <span class="vf-tiptap-mention-header-hints">
                    <kbd class="vf-tiptap-mention-kbd">↑</kbd>
                    <kbd class="vf-tiptap-mention-kbd">↓</kbd>
                    <span>navigate</span>
                    <span class="vf-tiptap-mention-dot">·</span>
                    <kbd class="vf-tiptap-mention-kbd">↵</kbd>
                    <span>select</span>
                    <span class="vf-tiptap-mention-dot">·</span>
                    <kbd class="vf-tiptap-mention-kbd">esc</kbd>
                </span>
            </div>
            <!-- The list is a listbox of options (CO-09). Focus stays in the editor; the editor's aria-controls names this element and its
                 aria-activedescendant the highlighted option, so a screen reader announces the person as the arrows move. -->
            <div class="vf-tiptap-mention-scroll" role="listbox" [attr.id]="slashListId" [attr.aria-label]="groupedHeaderLabel">
                <ng-container *ngFor="let item of slashItems; trackBy: trackBySlashItem; let i = index">
                    <!-- Group header rendered before the first item of each group.
                         Skipped entirely when the row has no `group` set (used by
                         the "Searching..." placeholder and similar bare rows). -->
                    <div *ngIf="item.group && (i === 0 || slashItems[i - 1].group !== item.group)"
                         class="vf-tiptap-mention-group-header" aria-hidden="true"
                         [style.borderLeftColor]="item.groupAccent || '#9ca3af'">
                        <span class="vf-tiptap-mention-group-icon">
                            <svg *ngIf="item.group === 'Files'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/>
                                <path d="M14 2v4a2 2 0 0 0 2 2h4"/>
                                <path d="M10 9H8"/>
                                <path d="M16 13H8"/>
                                <path d="M16 17H8"/>
                            </svg>
                            <svg *ngIf="item.group === 'Tasks'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10"/>
                                <path d="m9 12 2 2 4-4"/>
                            </svg>
                            <svg *ngIf="item.group === 'Clients'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                                <circle cx="9" cy="7" r="4"/>
                                <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                            </svg>
                        </span>
                        <span class="vf-tiptap-mention-group-name">{{ item.group }}</span>
                        <span class="vf-tiptap-mention-group-count" *ngIf="item.groupCount">{{ item.groupCount }}</span>
                    </div>

                    <div class="vf-tiptap-mention-row"
                         role="option" [attr.id]="item.optionId" [attr.aria-selected]="i === slashSelectedIndex"
                         [class.is-selected]="i === slashSelectedIndex"
                         [style.borderLeftColor]="i === slashSelectedIndex ? (item.groupAccent || '#2563eb') : 'transparent'"
                         (mousedown)="$event.preventDefault()"
                         (click)="selectSlashItem(item, i)">
                        <!-- Type glyph normally; falls back to the avatar/initials a PEOPLE row carries,
                             so an @mention list keeps its faces when a host turns the grouped layout on
                             for its `/` picker (both triggers share this popup). -->
                        <!-- `rowIconSafe`, not `rowIconSvg`: the sanitizer strips <svg> from a raw string,
                             which left every row's icon slot blank. -->
                        <span class="vf-tiptap-mention-row-icon" aria-hidden="true"
                              *ngIf="item.rowIconSafe" [innerHTML]="item.rowIconSafe"></span>
                        <img *ngIf="!item.rowIconSvg && item.iconUrl" [src]="item.iconUrl"
                             class="vf-tiptap-mention-row-avatar" alt="">
                        <span *ngIf="!item.rowIconSvg && !item.iconUrl && item.iconInitials" aria-hidden="true"
                              class="vf-tiptap-mention-row-avatar vf-tiptap-mention-row-avatar--fallback">{{ item.iconInitials }}</span>
                        <span class="vf-tiptap-mention-row-text">
                            <span class="vf-tiptap-mention-row-title">{{ item.text }}</span>
                            <span class="vf-tiptap-mention-row-breadcrumb" *ngIf="item.breadcrumb">{{ item.breadcrumb }}</span>
                        </span>
                    </div>
                </ng-container>
            </div>

            <!-- The empty text is a SIBLING of the listbox, not a child: a listbox owns options only, and a text div inside it with no
                 option beside it fails axe's aria-required-children when the people list shows "No matches" (CMT-35 step 5, CMT-42). -->
            <div *ngIf="!slashItems.length" class="vf-tiptap-mention-empty">
                <ng-container *ngIf="slashQuery">No matches for "{{ slashQuery }}". Keep typing, or press <kbd class="vf-tiptap-mention-kbd">esc</kbd> to dismiss.</ng-container>
                <ng-container *ngIf="!slashQuery">Type to search files, tasks, and clients.</ng-container>
            </div>
        </ng-container>
    </div>

    <!-- Drop-zone indicator (only visible while a file is being dragged over the editor) -->
    <div class="vf-tiptap-drop-indicator" aria-hidden="true">
        <div class="vf-tiptap-drop-indicator-card">
            <lucide-icon name="upload" [size]="20" [strokeWidth]="2"></lucide-icon>
            <div class="vf-tiptap-drop-indicator-text">
                <div class="vf-tiptap-drop-indicator-title">Drop to attach</div>
                <div class="vf-tiptap-drop-indicator-sub">{{ fileDropHintText }}</div>
            </div>
        </div>
    </div>

    <!-- Upload files modal — opens on paste/drop of an image -->
    <vf-image-upload-modal
        [open]="showImageUploadModal"
        [file]="pendingImageFile"
        [projectId]="projectId"
        [taskId]="taskId"
        (closeModal)="closeImageUploadModal()"
        (uploadComplete)="onImageUploadComplete($event)">
    </vf-image-upload-modal>

    <!-- Lightbox — opens when an inline image card is clicked -->
    <vf-image-lightbox
        [open]="showLightbox"
        [imageUrl]="lightboxImageUrl"
        [fileName]="lightboxFileName"
        [fileSize]="lightboxFileSize"
        [fileExtension]="lightboxExtension"
        [webUrl]="lightboxWebUrl"
        [loading]="lightboxLoading"
        (closed)="closeLightbox()">
    </vf-image-lightbox>
</div>
